var default_call = {
    "endpoint": 0,
    "content": {
        "args": {}
    }
};

async function Generic_Call(sys_body) 
{
    let baseURL = "";
    if (process.env.REACT_APP_STAGE === "prod") {
        baseURL = `https://wzl6hj9sl6.execute-api.us-east-1.amazonaws.com/latest/${sys_body.endpoint}`;
    }
    else {
        baseURL = `https://762z1qbh67.execute-api.us-east-1.amazonaws.com/latest/${sys_body.endpoint}`;
    }
    let server_response = {};
    try {        
        server_response = await fetch(baseURL, {method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                },
                                                body: JSON.stringify(sys_body.content)
                                                });

        if (!server_response.ok) {
            server_response = {};
            throw new Error(`HTTP error! Status: ${server_response.status}`);
        }
        return await server_response.json();
    } catch (error) {
        console.error('Fetch error:', error);
        return await server_response;
    }
}
export function validateEmailData(param0) {
    let valid = true;
    try {
        let data = param0.split("@");
        if ((data[0].length < 1) || (data[0].length > 64)) {
            valid = false;
        }
        if (valid) {
            if ((data[1].length < 2) || (data[1].length > 252)) {
                valid = false;
            }
        }
    }
    catch (error) {
        valid = false;
    }
    return valid;
}
export async function login(param0, param1) {
    var data = {
        "EMAIL": "",
        "PASS": ""
    };
    var payload = {};

    data.EMAIL                  = param0;
    data.PASS                   = param1;
    default_call.endpoint       = "uaf1";
    default_call.content.args   = data;
    
    payload = await Generic_Call(default_call);
    
    return (payload);
}
export async function msLogin(param0) {
    var data = {
        "AUTHORIZATION": ""
    };
    var payload = {};
    
    data.AUTHORIZATION          = param0;
    default_call.endpoint       = "uaf2";
    default_call.content.args   = data;

    payload = await Generic_Call(default_call);
    
    return (payload);
}
export async function getRecoveryCode(param0) {
    var data = {
        "EMAIL": ""
    };
    var payload = {};
    
    data.EMAIL                  = param0;
    default_call.endpoint       = "uaf3";
    default_call.content.args   = data;

    payload = await Generic_Call(default_call);
    
    return (payload);
}
export async function getNewPass(param0) {
    var data = {
        "CODE": ""
    };
    var payload = {};
    
    data.CODE                   = param0;
    default_call.endpoint       = "uaf4";
    default_call.content.args   = data;

    payload = await Generic_Call(default_call);
    
    return (payload);
}